<template>
  <div class="corp-profit">
    <template-form
      :isBack="true"
      title="ทีนี้มาลองคำนวณความต่างของกำไร"
      description="เปรียบเทียบการจด VAT/ ไม่จด VAT"
    >
      <div class="cpb-answer">
        {{ labelIncome }}
        <currency v-model="onlineSelling" v-on:change="setOnlineSelling" />
      </div>
      <div class="cpb-answer">
        {{ labelCost }}
        <currency v-model="cost" v-on:change="setCost" />
      </div>

      <material-button
        class="cpb-button"
        :disabled="!validate"
        @clickButton="$router.push('/forms/register_vat_compare')"
      >
        ถัดไป
      </material-button>
    </template-form>
    <modal v-if="isOpenModal">
      <div slot="body">
        <img
          :src="VECTOR"
          class="img-vector"
          style="margin-top: 20px; margin-bottom: 30px;"
        />
        <div class="red-modal" style="margin-bottom: 10px;">
          <div>จากลักษณะธุรกิจของคุณเราแนะนำ</div>
          ให้จดทะเบียนภาษีมูลค่าเพิ่ม (VAT)
        </div>
        <div class="break">
          <div>เพื่อหลีกเลี่ยงค่าใช้จ่ายเพิ่มเติมที่เกิดจากเบี้ยปรับ</div>
          และค่าปรับอาญา จากการทำผิดกฎหมาย
        </div>
        <chevron-right-link
          @clickLink="goToFineDetail"
          caption="รายละเอียดค่าปรับต่างๆ"
          style="margin: 15px 0 0 0; justify-content: center;"
        />
      </div>
      <div slot="footer" class="footer-modal">
        <material-button
          class="ptcb-button button-secondary btn-size"
          @clickButton="closeModal"
        >
          ปิด
        </material-button>
      </div>
    </modal>
    <StateAnswer />
  </div>
</template>

<script>
import StateAnswer from "@/components/StateAnswer.vue";
import VECTOR from "@/assets/images/vector-alert.png";

export default {
  name: "CorpProfit",
  components: {
    StateAnswer,
  },
  data() {
    const onlineSelling = this.$store.getters["taxInfo/getIncome"]
      .onlineSelling;
    const cost = this.$store.getters["taxInfo/getExpense"].cost;
    const labelIncome = "รายได้จากการขายสินค้าต่อเดือน (ไม่รวม VAT)";
    const labelCost = "ต้นทุนสินค้าต่อเดือน (รวม VAT)";

    return {
      onlineSelling,
      cost,
      VECTOR,
      isOpenModal: true,
      labelIncome: labelIncome,
      labelCost: labelCost,
    };
  },
  methods: {
    closeModal() {
      this.isOpenModal = false;
    },
    setOnlineSelling(value) {
      this.$store.dispatch("taxInfo/addIncomeValue", {
        name: "onlineSelling",
        value: value,
      });
    },
    setCost(value) {
      this.$store.dispatch("taxInfo/addExpenseValue", {
        name: "cost",
        value: value,
      });
    },
    goToFineDetail() {
      this.$router.push({
        path: "/info/fine_detail",
      });
    },
  },
  computed: {
    validate: function () {
      const onlineSelling = this.$store.state.taxInfo.income.onlineSelling;
      const cost = this.$store.state.taxInfo.expense.cost;

      let valid = false;
      if (onlineSelling > 0) {
        if (cost > 0) {
          valid = true;
        }
      }
      return valid;
    },
  },
};
</script>

<style scoped>
.corp-profit {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  justify-content: space-between;
}
.red-modal {
  color: #f45a49;
  font-weight: bold;
  font-size: 19px;
}
.cpb-answer {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  max-width: 352px;
  box-sizing: border-box;
}
.cpb-button {
  max-width: 352px;
  margin-top: 16px;
  margin-bottom: 14px;
}
</style>
